import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App.tsx';

import '@kolking/react-ui/styles/style.css';
import './styles/index.scss';

const container = document.getElementById('root')!;
const root = createRoot(container, {
  // Handle uncaught errors during rendering
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),

  // Handle errors caught by Error Boundary
  onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Caught error', error, errorInfo.componentStack);
  }),

  // Handle recoverable errors
  onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Recoverable error', error, errorInfo.componentStack);
  }),
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
